import React, { createContext, useState, useEffect } from "react";
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "../utils/constants";
import {jwtDecode} from "jwt-decode";
import { fetchMyStorefront } from "../services/appServices";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true); // NEW
    const [userInfo, setUserInfo] = useState({});

    // Function to log in (store token)
    const login = (accessToken, refreshToken) => {
        localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
        setIsAuthenticated(true);
        try {
            const decoded = jwtDecode(accessToken);
            setUserInfo({
                first_name: decoded.first_name,
                last_name: decoded.last_name,
                email: decoded.email,
                is_vendor: decoded.is_vendor,
                is_organizer: decoded.is_organizer,
            });
        } catch (e) {
            console.error("Failed to decode token on login", e);
        }
    };

    // Function to log out (clear token)
    const logout = () => {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        setIsAuthenticated(false);
        setUserInfo({});
    };

    // Check authentication status on mount
    useEffect(() => {
        const initializeAuth = async () => {
            const token = localStorage.getItem("access_token");
            if (token) {
                setIsAuthenticated(true);

                let storefrontRes = {}
                try {
                    const res = await fetchMyStorefront(login, logout);
                    storefrontRes = res
                }
                catch {
                    storefrontRes = { success: false, data: {} }
                }
                try {
                    const decoded = jwtDecode(token);
                    setUserInfo({
                        first_name: decoded.first_name,
                        last_name: decoded.last_name,
                        email: decoded.email,
                        is_vendor: storefrontRes?.success ? true: decoded.is_vendor,
                        is_organizer: decoded.is_organizer,
                    });
                } catch (e) {
                    console.error("Failed to decode token", e);
                }
            } else {
                setIsAuthenticated(false);
                setUserInfo({});
            }
            setIsLoading(false);
        };

        initializeAuth();
    }, []);

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, isLoading, userInfo }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => React.useContext(AuthContext);